<template>
  <gh-table-page v-model="selecteds" ref="table" :show-tabs="true" :args-query="argsQuery" module="plat.file"
    cls="FileService">
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="argsQuery.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query(argsQuery)">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
    <template #area_operation_before>
      <v-menu v-model="menu" offset-y :close-on-click="false" :close-on-content-click="false"
        v-if="selecteds.length === 1">
        <template #activator="{on}">
          <slot name="activator" :on="on">
            <v-btn color="primary" dark slot="activator" v-on="on">上传</v-btn>
          </slot>
        </template>
        <v-card class="white">
          <gh-upload :id="selecteds[0].Id">
          </gh-upload>
          <v-card-actions style="background: white">
            <v-spacer></v-spacer>
            <v-btn flat @click="menu = false">关闭</v-btn>
            <!-- <v-btn color="primary" flat @click="submit()" v-if="allowSubmit">确认</v-btn> -->
          </v-card-actions>

        </v-card>
      </v-menu>



    </template>
    <template #model-prop-Value="{prop,model}">
      <gh-upload v-if="!model.Id"></gh-upload>
    </template>
    <template #area_detail="{current}">
      <div v-if="current">
        <gh-pdf :id="current.Id" v-if="current.Type==='application/pdf'"></gh-pdf>
        <gh-video v-else-if="current.Type.indexOf('video') >- 1 " :source="current.Id"></gh-video>
        <gh-img v-else :id="current.Id"></gh-img>
      </div>
    </template>


  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import File from "./file.ts";
  export default File;
</script>